import { getEffectiveTranslations } from './i18n';

function t(lang, key) { return getEffectiveTranslations(lang||'en')[key]||key; }

// ── BeeLove Safety & Moderation System ───────────────────────────────────

export function getReportReasons(lang) { return [
  { id: 'fake_profile',    label: t(lang,'report.reason_fake'),      severity: 'high'    },
  { id: 'harassment',      label: t(lang,'report.reason_harassment'), severity: 'high'    },
  { id: 'inappropriate',   label: t(lang,'report.reason_content'),    severity: 'medium'  },
  { id: 'spam',            label: t(lang,'report.reason_spam'),       severity: 'high'    },
  { id: 'underage',        label: t(lang,'report.reason_underage'),   severity: 'critical'},
  { id: 'offensive',       label: t(lang,'report.reason_offensive'),  severity: 'medium'  },
  { id: 'stolen_identity', label: 'Stolen identity / catfishing',     severity: 'high'    },
  { id: 'other',           label: t(lang,'report.reason_other'),      severity: 'low'     },
]; }
export const REPORT_REASONS = getReportReasons('en');

export function getModerationActions(lang) { return {
  warn:    { label:t(lang,'mod.warn'),    color: '#C9A84C', icon: '⚠️' },
  suspend: { label:t(lang,'mod.suspend'), color: '#E07070', icon: '⏸'  },
  ban:     { label:t(lang,'mod.ban'),     color: '#C94C4C', icon: '🚫'  },
  dismiss: { label:t(lang,'mod.dismiss'), color: '#7A768A', icon: '✓'   },
}; }
export const MODERATION_ACTIONS = getModerationActions('en');

// Reports are stored in Supabase — use db.reports() and db.blocks()

export function fileReport(reporterId, targetId, reason, details = '') {
  const report = {
    id:         'rep_' + Date.now(),
    reporterId,
    targetId,
    reason,
    details,
    status:     'pending',
    createdAt:  new Date().toISOString(),
    resolvedAt: null,
    action:     null,
  };
  try {
    const existing = JSON.parse(localStorage.getItem('beeloveReports') || '[]');
    existing.push(report);
    localStorage.setItem('beeloveReports', JSON.stringify(existing));
  } catch {}
  return report;
}

export function getReports() {
  try {
    return JSON.parse(localStorage.getItem('beeloveReports') || '[]');
  } catch { return []; }
}

export function resolveReport(reportId, action, adminNote = '') {
  try {
    const reports = getReports();
    const updated = reports.map(r =>
      r.id === reportId
        ? { ...r, status: 'resolved', action, adminNote, resolvedAt: new Date().toISOString() }
        : r
    );
    localStorage.setItem('beeloveReports', JSON.stringify(updated));
    const log = JSON.parse(localStorage.getItem('beeloveModerationLog') || '[]');
    log.push({ reportId, action, adminNote, at: new Date().toISOString() });
    localStorage.setItem('beeloveModerationLog', JSON.stringify(log));
  } catch {}
}

export async function blockUser(myId, targetId) {
  // Optimistic UI cache
  try {
    const blocked = JSON.parse(localStorage.getItem('beeloveBlocked') || '{}');
    if (!blocked[myId]) blocked[myId] = [];
    if (!blocked[myId].includes(targetId)) blocked[myId].push(targetId);
    localStorage.setItem('beeloveBlocked', JSON.stringify(blocked));
  } catch {}
  // Persist to Supabase
  try {
    const { db } = await import('./supabase');
    await db.blocks()?.insert({ blocker_id: myId, blocked_id: targetId });
  } catch {}
}

export function unblockUser(myId, targetId) {
  try {
    const blocked = JSON.parse(localStorage.getItem('beeloveBlocked') || '{}');
    if (blocked[myId]) blocked[myId] = blocked[myId].filter(id => id !== targetId);
    localStorage.setItem('beeloveBlocked', JSON.stringify(blocked));
  } catch {}
}

export async function getBlockedIds(myId) {
  try {
    const { db } = await import('./supabase');
    const { data } = await db.blocks()?.select('blocked_id').eq('blocker_id', myId) || {};
    if (data) {
      const ids = data.map(r => r.blocked_id);
      const blocked = JSON.parse(localStorage.getItem('beeloveBlocked') || '{}');
      blocked[myId] = ids;
      localStorage.setItem('beeloveBlocked', JSON.stringify(blocked));
      return ids;
    }
  } catch {}
  // Fallback to localStorage cache
  try {
    const blocked = JSON.parse(localStorage.getItem('beeloveBlocked') || '{}');
    return blocked[myId] || [];
  } catch { return []; }
}

export function getBlockedIdsSync(myId) {
  try {
    const blocked = JSON.parse(localStorage.getItem('beeloveBlocked') || '{}');
    return new Set(blocked[myId] || []);
  } catch { return new Set(); }
}

export function isBlocked(myId, targetId) {
  try {
    const blocked = JSON.parse(localStorage.getItem('beeloveBlocked') || '{}');
    return (blocked[myId] || []).includes(targetId);
  } catch { return false; }
}

export function getSuspendedUsers() {
  try {
    return JSON.parse(localStorage.getItem('beeloveSuspended') || '{}');
  } catch { return {}; }
}

export function suspendUser(userId, daysOrPermanent, reason) {
  try {
    const suspended = getSuspendedUsers();
    suspended[userId] = {
      until: daysOrPermanent === 'permanent' ? 'permanent' : new Date(Date.now() + daysOrPermanent * 86400000).toISOString(),
      reason,
      at: new Date().toISOString(),
    };
    localStorage.setItem('beeloveSuspended', JSON.stringify(suspended));
  } catch {}
}

export function isSuspended(userId) {
  const suspended = getSuspendedUsers();
  if (!suspended[userId]) return false;
  if (suspended[userId].until === 'permanent') return true;
  return new Date(suspended[userId].until) > new Date();
}
